<ng-container *ngIf="display_type == 1 || !display_type">
  <div class="steps-container">
    <ng-container *ngFor="let section of sections;let index=index">
      <div *ngIf="section.status != 4" (click)="setActiveStepper(index, section.type, section)" class="step"
        [ngClass]="{'active':index == current_step.index, 'last-step':index == ((sections|FetchActiveStepsCount) - 1), 'disabled':section.status == 3}"
        [ngStyle]="{'width':(100/(sections|FetchActiveStepsCount)-0.25)+'%'}">
        <span class="step-title">
          <img class="step-title-icon" *ngIf="section.icon" [src]="section.icon" alt="">
          {{section.title}}
        </span>
      </div>
    </ng-container>
  </div>
  <div class="container-fluid mt-1" *ngFor="let section of sections;let index=index">

    <div class="row" *ngIf="index == current_step.index">
      <div class="col-md-6" #tablediv style="overflow: auto;">
        <table class="table onb-table bor" style="display: inline-block;">
          <tbody>
            <ng-container *ngFor="let item of (section.sectionFields||[]); let j = index;">
              <ng-container *ngIf="j <= (section.sectionFields.length/2)">
                <ng-container *ngTemplateOutlet="tr; context: {item: item, index: j,section : section}">
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>

        </table>
      </div>
      <div class="col-md-6" #tablediv style="overflow: auto;">
        <table class="table onb-table" style="display: inline-block;">
          <tbody>
            <ng-container *ngFor="let item of (section.sectionFields||[]); let j = index;">
              <ng-container *ngIf="j > (section.sectionFields.length/2)">
                <ng-container *ngTemplateOutlet="tr; context: {item: item, index: j,section : section}">
                </ng-container>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row form-group" *ngIf="index == current_step.index">
      <div class="col-md-12 text-right">
        <button style="min-width: 100px;" class="blob-btn float-right btn   mx-1 float-right tallite-action"
          type="submit" (click)="saveSection(section, form_group.get(section.title))">
          <!-- -->
          {{ 'BTN.submit' | translate }}
          <span class="blob-btn__inner">
            <span class="blob-btn__blobs">
              <span class="blob-btn__blob"></span>
              <span class="blob-btn__blob"></span>
              <span class="blob-btn__blob"></span>
              <span class="blob-btn__blob"></span>
            </span>
          </span>
        </button>
      </div>
    </div>


  </div>
</ng-container>

<ng-container *ngIf="display_type == 2">
  <!-- <div class="accordions"> -->
  <ng-container *ngFor="let section of sections;let i = index;">
    <div class="accordion">
      <input type="radio" [checked]="i == 0 ? true : false" class="rd" [id]="'section'+section.code" name="rd">
      <div (click)="checkDOMElement('section'+section.code,$event)">
        <label [attr.for]="'section'+section.code" class="accordion-label text-right">
          <span class="float-left">
            {{section.title | translate}}
          </span>
        </label>
      </div>
      <div class="accordion-content">
        <div class="row">
          <div class="col-md-6" #tablediv style="overflow: auto;">
            <table class="table onb-table bor" style="display: inline-block;">
              <tbody>
                <ng-container *ngFor="let item of (section.sectionFields||[]); let j = index;">
                  <ng-container *ngIf="j <= (section.sectionFields.length/2)">
                    <ng-container *ngTemplateOutlet="tr; context: {item: item, index: j,section : section}">
                    </ng-container>
                  </ng-container>
                </ng-container>
              </tbody>

            </table>
          </div>
          <div class="col-md-6" #tablediv style="overflow: auto;">
            <table class="table onb-table" style="display: inline-block;">
              <tbody>
                <ng-container *ngFor="let item of (section.sectionFields||[]); let j = index;">
                  <ng-container *ngIf="j > (section.sectionFields.length/2)">
                    <ng-container *ngTemplateOutlet="tr; context: {item: item, index: j,section : section}">
                    </ng-container>
                  </ng-container>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  </ng-container>

  <!-- </div> -->
</ng-container>

<ng-container *ngIf="display_type == 3">
  <div class="row vertical-nav-v2">
    <div class="col-md-3" aria-hidden="false">
      <div class="">
        <h6 class="text-center action-header">
          Actions
        </h6>
      </div>
      <div class="">
        <ng-container *ngFor="let section of sections;let i = index;">
          <a class="section_type-7 nav_section_title" (click)="setActiveSection(section)"
            [ngClass]="{'active': section.active}">
            <div class="title">
              {{section.title}}
            </div>
            <div class="progress-title">
              <div class="progress" [attr.data-percentage]="section.progressPercentage">
                <span class="progress-left">
                  <span class="progress-bar"></span>
                </span>
                <span class="progress-right">
                  <span class="progress-bar"></span>
                </span>
                <div class="progress-value mx-auto">
                  {{ section.progressPercentage }}%
                </div>
              </div>
            </div>
          </a>
        </ng-container>
      </div>

    </div>

    <div class="col-md-9">
      <div *ngFor="let section of sections; let i = index">
        <ng-container *ngIf="section.active">
          <h6 class="section_title">
            <span>{{section.title}}</span>
          </h6>

          <div class="px-10px">
            <form [formGroup]="form_group">
              <div class="row">
                <div class="col-md-6" #tablediv style="overflow: auto;">

                  <ng-container *ngFor="let item of (section.sectionFields||[]); let j = index;">
                    <ng-container *ngIf="j <= (section.sectionFields.length/2)">
                      <ng-container *ngTemplateOutlet="tr; context: {item: item, index: j,section : section}">
                      </ng-container>
                    </ng-container>
                  </ng-container>

                </div>
                <div class="col-md-6" #tablediv style="overflow: auto;">

                  <ng-container *ngFor="let item of (section.sectionFields||[]); let j = index;">
                    <ng-container *ngIf="j > (section.sectionFields.length/2)">
                      <ng-container *ngTemplateOutlet="tr; context: {item: item, index: j,section : section}">
                      </ng-container>
                    </ng-container>
                  </ng-container>

                </div>
              </div>
            </form>

          </div>
        </ng-container>
      </div>
    </div>
  </div>
</ng-container>








<!-- 0: {id: 1, title: "Text"}
1: {id: 2, title: "Number"}
2: {id: 3, title: "Date"}
3: {id: 4, title: "Date time"}
4: {id: 5, title: "Single file select"}
5: {id: 6, title: "Multi file select"} -->
<ng-template #edit_mode let-item="item" let-hide_label="hide_label" let-width="width" let-section="section">
  <form [formGroup]="form_group.get(section.title)" class="dynmaic_form">
    <ng-container *ngIf="item.dataTypeId==1">
      <!-- TEXT -->
      <mat-form-field [appearance]="appearance" floatLabel='always'>
        <mat-label [class]="item.labelClass ? 'text-nowrap ' +item.labelClass :'text-nowrap'"
          [title]="(item.title || '')|HTMLFormatter" [ngClass]="{'req':item.mandatory}">
          <span *ngIf="item.title" [innerHTML]="item.title|HTMLFormatter"></span>
        </mat-label>
        <input matInput [formControlName]="item.title" [placeholder]="item.placeHolder">
        <!-- [min]="item.min ? item.min : 99999999999" [max]=" item.max ? item.max : 99999999999"
          [minLength]="item.minLength ? item.minLength : 99999999999"
          [maxLength]="item.maxLength ? item.maxLength :99999999999"> -->


        <mat-error
          *ngIf="form_group.get(section.title) && form_group.get(section.title).get(item.title).hasError('required');else maxlength">
          Field is mandatory
          <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
        </mat-error>
        <ng-template #maxlength>
          <mat-error
            *ngIf="form_group.get(section.title) && form_group.get(section.title).get(item.title).hasError('maxlength');else minlength">
            Maximum length ({{item.maxLength}}) has exceeded
          </mat-error>
        </ng-template>
        <ng-template #minlength>
          <mat-error
            *ngIf="form_group.get(section.title) && form_group.get(section.title).get(item.title).hasError('minlength'); else maxvalue">
            Minimum length must be ({{item.minLength}})
          </mat-error>
        </ng-template>
        <ng-template #maxvalue>
          <mat-error
            *ngIf="form_group.get(section.title) && form_group.get(section.title).get(item.title).hasError('max');else minvalue">
            Value must be lesser than {{item.max}}
          </mat-error>
        </ng-template>
        <ng-template #minvalue>
          <mat-error
            *ngIf="form_group.get(section.title) && form_group.get(section.title).get(item.title).hasError('min'); else pattern">
            Value must be greater than {{item.min}}
          </mat-error>
        </ng-template>
        <ng-template #pattern>
          <mat-error
            *ngIf="form_group.get(section.title) && form_group.get(section.title).get(item.title).hasError('pattern')">
            {{'Invalid input'}}
          </mat-error>
        </ng-template>
      </mat-form-field>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId==2">
      <!-- NUMBER -->
      <mat-form-field [appearance]="appearance" floatLabel="always">
        <mat-label [class]="item.labelClass ? 'text-nowrap ' +item.labelClass :'text-nowrap'"
          [title]="(item.title || '')|HTMLFormatter" [ngClass]="{'req':item.mandatory}">
          <span *ngIf="item.title" [innerHTML]="item.title|HTMLFormatter"></span>
        </mat-label>
        <input matInput type="number" [formControlName]="item.title" [placeholder]="item.placeHolder">
        <mat-error
          *ngIf="form_group.get(section.title) && form_group.get(section.title).get(item.title).hasError('required');else maxlength">
          Field is mandatory
          <!-- <span [innerHTML]="label + ' is mandatory'"></span> -->
        </mat-error>
        <ng-template #maxlength>
          <mat-error
            *ngIf="form_group.get(section.title) && form_group.get(section.title).get(item.title).hasError('maxlength');else minlength">
            Maximum length ({{item.maxLength}}) has exceeded
          </mat-error>
        </ng-template>
        <ng-template #minlength>
          <mat-error
            *ngIf="form_group.get(section.title) && form_group.get(section.title).get(item.title).hasError('minlength'); else maxvalue">
            Minimum length must be ({{item.minLength}})
          </mat-error>
        </ng-template>
        <ng-template #maxvalue>
          <mat-error
            *ngIf="form_group.get(section.title) && form_group.get(section.title).get(item.title).hasError('max');else minvalue">
            Value must be lesser than {{item.max}}
          </mat-error>
        </ng-template>
        <ng-template #minvalue>
          <mat-error
            *ngIf="form_group.get(section.title) && form_group.get(section.title).get(item.title).hasError('min'); else pattern">
            Value must be greater than {{item.min}}
          </mat-error>
        </ng-template>
        <ng-template #pattern>
          <mat-error
            *ngIf="form_group.get(section.title) && form_group.get(section.title).get(item.title).hasError('pattern')">
            {{'Invalid input'}}
          </mat-error>
        </ng-template>
      </mat-form-field>

    </ng-container>
    <ng-container *ngIf="item.dataTypeId==3">
      <!-- DATE -->
      <tm-date-picker [form]="form_group.get(section.title)" [controlName]="item.title"
        [required]="item.mandatory ? true: false"
        [value]="form_group.get(section.title).value &&form_group.get(section.title).value[item.title]"
        [placeholder]="item.placeHolder" [label]="item.title" [appearance]="appearance">
      </tm-date-picker>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId==4">
      <!-- DATE & TIME -->
      <app-date-time-picker [form]="form_group.get(section.title)" [controlName]="item.title"
        [required]="item.mandatory ? true: false"
        [value]="form_group.get(section.title).value &&form_group.get(section.title).value[item.title]"
        [placeholder]="item.placeHolder" [label]="item.title" [appearance]="appearance"></app-date-time-picker>
    </ng-container>
    <ng-container *ngIf="item.dataTypeId==5">
      <!-- SINGLE FILE -->
      <tm-files-v2 [form_group]="form_group.get(section.title)" [required]="item.mandatory ? true: false"
        [form_control]="item.title" [label]="item.title" [style]="{'margin-bottom':'0px'}" [multiple]="0"
        [result]="form_group.get(section.title).value && form_group.get(section.title).value[item.title]">
      </tm-files-v2>

    </ng-container>
    <ng-container *ngIf="item.dataTypeId==6">
      <!-- MULTIPE FILES -->
      <tm-files-v2 [form_group]="form_group.get(section.title)" [required]="item.mandatory ? true: false"
        [style]="{'margin-bottom':'0px'}" [form_control]="item.title" [label]="item.title" [multiple]="1"
        [result]="form_group.get(section.title).value &&form_group.get(section.title).value[item.title]">
      </tm-files-v2>
    </ng-container>

    <!-- Single select -->

    <ng-container *ngIf="item.dataTypeId==7">
      <tm-select [options]="item.list ||[]" [id_property]="item.id_property || 'code'"
        [title_property]="item.title_property || 'title'"
        [data]="form_group.get(section.title).value &&form_group.get(section.title).value[item.title]"
        [form_group]="form_group.get(section.title)" [mandatory]="item.mandatory" [form_control]="item.title"
        [label]="item.title" [hide_label]="item.hide_label" [label_overflow]="item.label_overflow" [label]="item.title">
      </tm-select>
    </ng-container>

    <!-- Multi select -->

    <ng-container *ngIf="item.dataTypeId==8">
      <tm-multi-select [options]="item.list ||[]" [id_property]="item.id_property || 'code'"
        [title_property]="item.title_property || 'title'"
        [data]="form_group.get(section.title).value &&form_group.get(section.title).value[item.title]"
        [form_group]="form_group.get(section.title)" [mandatory]="item.mandatory" [form_control]="item.title"
        [hide_label]="item.hide_label" [label_overflow]="item.label_overflow" [label]="item.title"
        [appearance]="appearance">
      </tm-multi-select>
    </ng-container>

    <ng-container *ngIf="item.dataTypeId==9">
      <app-phone-number [hide_label]="item.hide_label" [placeholder]="item.placeHolder" [options]="item.list"
        [options_data]="item.option_form_control && item.option_form_control !=''?form_group.get(section.title).value
                 && form_group.get(section.title).value[item.option_form_control] :null " [maxLength]="item.maxLength"
        [option_form_control]="item.option_form_control" [form]="form_group.get(section.title)"
        [controlName]="item.title" [label]="item.label" [data]="form_group.get(section.title).value
                &&form_group.get(section.title).value[item.title]" [pattern_desc]="'^[0-9]*$'" [required]="1"
        [appearance]="appearance">
      </app-phone-number>
    </ng-container>
  </form>

</ng-template>

<ng-template #tr let-item="item" let-index="index" let-section="section">
  <div [ngClass]="item.field_class" [ngStyle]="item.field_css | AddNgStylePipe : {}" class=" row field-container">
    <div class="col-sm-9 my-auto">
      <ng-container *ngIf="item.isEdit">
        <ng-template *ngTemplateOutlet="edit_mode; context: {item:item,hide_label:1,width:12,section : section}">
        </ng-template>
      </ng-container>
      <ng-container *ngIf="!item.isEdit">
        <ng-template
          *ngTemplateOutlet="read_only_mode_data; context: {item:item,hide_label:1,width:12,section : section}">
        </ng-template>
      </ng-container>
    </div>
    <div class="col-sm-3 my-auto">
      <div class="status-container">

        <ng-container *ngFor="let btn of verification_status_list">

          <div *ngIf="item.dataStatus == btn.id" style="font-size: 13px !important;"
            [ngClass]="{'pending':btn.id==1,'review':btn.id==2,'verified':btn.id==3,'declined':btn.id==4 }"
            [matTooltip]="btn.title">
            <i class="fa " [ngClass]="btn.icon"></i> {{btn.title}}
          </div>


        </ng-container>

        <div>
          <i class="fa fa-commenting-o pointer" style="font-size: 13px !important;" title="Notes"
            (click)="openNotesModal(item)"></i>
          <span *ngIf="item && item.notes_count" class="notes-count-badge">{{item.notes_count}}</span>

          <i class="fa fa-info ml-2 pointer d-inline-block" style="font-size: 13px !important;"
            [title]="item.info || item.title"></i>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #read_only_mode_data let-item="item">
  <ng-container>
    <ng-container *ngIf="item.dataTypeId == 7">
      <div (click)="onEmailClick()">
        {{item.value}}</div>
    </ng-container>

    <!-- Date -->
    <ng-container *ngIf="item.dataTypeId == 3">
      {{item.value | UtcToLocalTime | date: 'd-MMM-yyyy'}}
      <!-- &nbsp;{{item.time_to_be_considered ? item.time_to_be_considered : ''}} -->
    </ng-container>

    <!-- Date time -->
    <ng-container *ngIf="item.dataTypeId == 4">
      {{item.value | UtcToLocalTime | date: 'd-MMM-yyyy h:mm a'}}
    </ng-container>


    <!-- For single / multiselect / radio buttons -->
    <!-- <ng-container *ngIf="item.master_prop_name">
            {{section_details.data[0][item.field_name] | DynamicFieldMasterTitle : masters[item.master_prop_name] :
            masters :
            selectedObjRef : item : form : parent_form : section_details.data}}
        </ng-container> -->

    <!-- Checkbox -->
    <ng-container *ngIf="item.dataTypeId == 12">
      <span [innerHTML]="((item.value | translate) |HTMLFormatter)">
      </span>
    </ng-container>


    <!-- For fields having control type as rating -->
    <!-- <ng-container *ngIf="item.dataTypeId == 13">
            <app-rating [max_value]="item.max_value" [min_value]="item.min_value" [readonly]="true"
                [value]="section_details.data[0][item.field_name]">
            </app-rating>
        </ng-container> -->

    <!-- For fields having control type as html text editor -->
    <ng-container *ngIf=" item.dataTypeId==17">
      <div [innerHtml]="item.value | HTMLFormatter ">
      </div>
    </ng-container>

    <!-- For fields having control type as documents -->
    <ng-container *ngIf="item.dataTypeId == 5 || item.dataTypeId == 6 ">
      {{item.value | DynamicFilesTitlePipe }}
      <span class="ml-1" *ngIf=" item.dataTypeId == 5">
        <a class="download" [attr.href]="''" [attr.download]="item.title" matTooltip="Download" target='_blank'>
          <i class="fa fa-download" aria-hidden="true"></i>
        </a>
      </span>
      <span *ngIf="item.value" class="ml-1"><i class="fa fa-external-link pointer" matTooltip="View" style="color:#555"
          (click)="viewDocument(item.value,null)"></i>
      </span>

      <!-- <div class="mt-4"
                *ngIf="section_details.data && section_details.data[0] && section_details.data[0][item.field_name] && section_details.data[0][item.field_name][0] && section_details.data[0][item.field_name][0]['file_path'] && section_details.data[0][item.field_name][0]['file_path'].indexOf('http') > -1 && section_details.data[0][item.field_name][0]['file_path'].split('.') && item.dataTypeId == 23">
                <object id="resumeViewer" frameborder="0" style="width: 100%;height: 500px;"
                    [data]="section_details.data[0][item.field_name][0]['file_path'] | SafeFilePipe"></object>
            </div> -->

    </ng-container>

    <!-- Phone number -->
    <!-- <ng-container *ngIf="item.dataTypeId == 21 || item.dataTypeId == 26">
            <span [ngClass]="{'a_link pointer': item.function_name && item.function_name !='' }"
                (click)="evalFunction(item.function_name,data,form,parent_form)">
                {{section_details.data[0][item.field_name]</span>
        </ng-container> -->

    <!-- Paragraph control -->
    <!-- <ng-container *ngIf="item.dataTypeId == 22">
            <span class="d-inline-block" (click)="evalFunction(item.function_name,data,form,parent_form)"
                [innerHtml]="(item.label_code && item.label_code != '' && !item.label_title) ? ((item.module_code+'_'+item.sub_module_code+'_'+item.form_code+'_'+item.label_code) | translate):(item.label_title || '')">
            </span>
        </ng-container> -->

    <!-- When control type is none of the above -->
    <ng-container *ngIf="item.dataTypeId !=5 && item.dataTypeId != 6 && item.dataTypeId != 3 && item.dataTypeId != 4 ">
      <span>
        {{item.value}}
      </span>

      <!-- Hardcoded for applicant details name click -->

      <!-- <span (click)=" item.func || LabelClicked(item)" [ngClass]="{ 'email' : (openMailer? true : false)}"
                *ngIf=" item.func || item.field_id == 10538">
                {{section_details.data[0][item.field_name]}}
            </span> -->
    </ng-container>
  </ng-container>
</ng-template>
